// src/services/settings.service.js
import { env } from "../config/env";
import { createClient } from "./http";

const api = createClient(env.WAREHOUSE_BASE_URL);

export const settingsService = {
  async listSettings(params = {}) {
    return api.get("/api/admin/settings", { params });
  },

  async getSetting(key) {
    return api.get(`/api/admin/settings/${encodeURIComponent(key)}`);
  },

  async createSetting(payload) {
    return api.post("/api/admin/settings", payload);
  },

  async updateSetting(key, payload) {
    return api.patch(`/api/admin/settings/${encodeURIComponent(key)}`, payload);
  },

  async upsertPreset(key, payload) {
    return api.put(
      `/api/admin/settings/preset/${encodeURIComponent(key)}`,
      payload
    );
  },

  async getPublicSettings(params = {}) {
    return api.get("/api/admin/settings/public", { params });
  },
    async getWarehouseFilterOptions(params = {}) {
    return api.get("/api/admin/warehouses/filter-options", { params });
  },
};